import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useQuickStartStatus } from '../hooks';
import { Progress } from '@backstage/core-components';

interface QuickStartGuardProps {
  children: React.ReactNode;
}

/**
 * Guard component that redirects first-time users to the quick start page.
 * This should wrap content that requires the quick start to be completed.
 */
export const QuickStartGuard = ({ children }: QuickStartGuardProps) => {
  const { isFirstTimeUser, isLoading } = useQuickStartStatus();
  const location = useLocation();

  // Don't redirect if we're already on the quick-start page
  if (location.pathname === '/quick-start') {
    return <>{children}</>;
  }

  if (isLoading) {
    return <Progress />;
  }

  if (isFirstTimeUser) {
    return <Navigate to="/quick-start" replace />;
  }

  return <>{children}</>;
};
